{
  "title": "Boîtes aux lettres",
  "subtitle": "Boîtes mises en miroir depuis l’annuaire, et la signature que chacune reçoit.",
  "listIntro": "Mises en miroir depuis l’annuaire du client. Les personnes apparaissent ici automatiquement dans les quinze minutes environ après leur création dans Microsoft 365.",
  "searchPlaceholder": "Rechercher un nom ou une adresse",
  "defaultTemplate": "Signature par défaut",
  "defaultIntro": "Appliquée à chaque boîte qui n’a rien de plus spécifique. Les règles opérateur et les signatures de groupe la remplacent ; une signature définie sur une personne ici remplace les deux.",
  "noPublishedTemplates": "Aucun modèle publié pour l’instant. Publiez-en un dans l’onglet Signatures et il pourra devenir le défaut du locataire.",
  "newMessages": "Nouveaux messages",
  "noDefault": "Aucun défaut défini",
  "repliesForwards": "Réponses et transferts",
  "sameAsNew": "Identique aux nouveaux messages",
  "saveDefault": "Enregistrer le défaut",
  "defaultCleared": "Défaut effacé. Les boîtes qui le suivaient ne sont plus estampillées.",
  "defaultSaved": "Défaut enregistré et appliqué à toutes les boîtes.",
  "saveFailed": "Impossible d’enregistrer.",
  "noMailboxesCovered": "Aucune boîte n’est encore couverte.",
  "coveredCount": "{{count}} boîte couverte.",
  "coveredCount_other": "{{count}} boîtes couvertes.",
  "coveredWithCustom": "{{covered}} boîtes couvertes, {{custom}} avec une signature définie individuellement.",
  "setDefault": "Définir le défaut",
  "colPerson": "Personne",
  "colSignature": "Signature",
  "colNewMessages": "Nouveaux messages",
  "colRepliesForwards": "Réponses et transferts",
  "previewNewAria": "Aperçu de la signature nouveaux messages {{name}}",
  "previewReplyAria": "Aperçu de la signature de réponse {{name}}",
  "colStamped": "Estampillé",
  "colSidebar": "Volet latéral",
  "colAllowChanges": "Autoriser les modifications",
  "colExcluded": "Exclu",
  "selectAllVisible": "Sélectionner toutes les boîtes visibles",
  "selectUser": "Sélectionner {{email}}",
  "emptySearch": "Personne ne correspond à cette recherche.",
  "emptyNone": "Aucune boîte n’a encore été synchronisée. Connectez un annuaire dans l’onglet Paramètres.",
  "showingFirst200": "Affichage des 200 premiers. Recherchez pour affiner la liste.",
  "addressesCount": "{{count}} adresses",
  "noMailbox": "Aucune boîte",
  "stateCustomised": "Personnalisé",
  "stateDefault": "Par défaut",
  "stateNotCovered": "Non couvert",
  "stateCustom": "Personnalisé",
  "stateExcluded": "Exclu",
  "stateRule": "Depuis une règle",
  "stateGroup": "Depuis un groupe",
  "previewAria": "Aperçu de la signature {{name}}",
  "stampAria": "Estampiller le courrier de {{email}}",
  "sidebarAria": "Proposer le volet latéral Outlook pour {{email}}",
  "sidebarTitle": "Proposer le volet de signature Outlook à cette personne",
  "allowChangesAria": "Autoriser les modifications de signature pour {{email}}",
  "allowChangesTitle": "Leur permettre de choisir une signature et de modifier des champs dans Outlook",
  "changeFailed": "Impossible de modifier cela.",
  "preview": "Aperçu",
  "whyThis": "Pourquoi celle-ci ?",
  "fields": "Champs",
  "customise": "Personnaliser",
  "revert": "Rétablir",
  "revertedToDefault": "{{name}} est de retour sur le défaut du locataire.",
  "unknownTemplate": "Modèle inconnu",
  "signatureFallback": "Signature",
  "massUpdate": "Mise à jour massive",
  "massUpdateCount": "Mise à jour massive ({{count}})",
  "selectedCount": "{{count}} sélectionné(s)",
  "massUpdateTitle": "Mise à jour massive",
  "massUpdateIntro": "Appliquer une modification à {{count}} boîte sélectionnée.",
  "massUpdateIntro_other": "Appliquer une modification à {{count}} boîtes sélectionnées.",
  "action": "Action",
  "actionPlaceholder": "Choisissez ce qu’il faut modifier",
  "actionStamp": "Estampiller (inclure dans les signatures)",
  "actionUnstamp": "Retirer l’estampille (exclure des signatures)",
  "actionCustomise": "Personnaliser la signature",
  "actionRevert": "Rétablir le défaut du locataire",
  "actionSidebarOn": "Volet latéral Outlook : activer",
  "actionSidebarOff": "Volet latéral Outlook : désactiver",
  "actionAllowOn": "Outlook : autoriser les modifications",
  "actionAllowOff": "Outlook : verrouiller les paramètres (aperçu uniquement)",
  "signature": "Signature",
  "choosePublished": "Choisir un modèle publié",
  "skippedNoMailbox": "{{count}} sans boîte seront ignorés.",
  "skippedNotCustomised": "{{count}} non personnalisés seront ignorés.",
  "nobodyEligible": "Personne dans la sélection ne peut recevoir cette modification.",
  "apply": "Appliquer",
  "updatedCount": "{{count}} boîte mise à jour.",
  "updatedCount_other": "{{count}} boîtes mises à jour.",
  "failedCount": "Impossible de mettre à jour {{count}} boîte.",
  "failedCount_other": "Impossible de mettre à jour {{count}} boîtes.",
  "partialUpdate": "{{succeeded}} mis à jour, {{failed}} en échec.",
  "massUpdateFailed": "Impossible d’appliquer cette mise à jour massive.",
  "customiseTitle": "Signature de {{name}}",
  "customiseIntro": "Cela fixe une boîte à une signature qui lui est propre. Elle prime sur les règles de groupe et le défaut du locataire, et cesse de suivre le défaut — y compris si le défaut change plus tard.",
  "setSignature": "Définir la signature",
  "customiseSuccess": "{{name}} a désormais sa propre signature.",
  "customiseFailed": "Impossible de définir cette signature.",
  "explainTitle": "Signature de {{name}}",
  "explainIntro": "Exécute la même évaluation que le parcours du courrier, face à un nouveau message vers un destinataire externe.",
  "explain": "Expliquer",
  "explainFailedTitle": "Impossible d’exécuter le test",
  "fieldsTitle": "Champs — {{name}}",
  "fieldsSaved": "Surcharges de champs enregistrées.",
  "fieldsSaveFailed": "Impossible d’enregistrer.",
  "photoAria": "Photo de {{email}}",
  "photoUploaded": "Photo téléversée",
  "photoFromDirectory": "Depuis l’annuaire",
  "uploadPhoto": "Téléverser une photo",
  "replacePhoto": "Remplacer la photo",
  "clearPhoto": "Effacer la photo",
  "removeUseDirectory": "Supprimer et utiliser celle de l’annuaire",
  "photoRemoved": "Photo supprimée. La prochaine synchronisation d’annuaire ramènera la leur s’ils en ont une.",
  "photoNotRemovedTitle": "Non supprimée",
  "photoNotRemoved": "Impossible de supprimer cette photo.",
  "photoUpdated": "Photo mise à jour.",
  "photoUpdatedTitle": "Photo mise à jour",
  "photoNotUploadedTitle": "Non téléversée",
  "photoNotUploaded": "Impossible de téléverser cette photo.",
  "photo": "Photo",
  "exclude": "Exclure de l’estampillage",
  "include": "Inclure dans l’estampillage",
  "editFields": "Modifier les champs",
  "outlookSetup": "Configuration du complément Outlook",
  "outlook": {
    "cardTitle": "Complément du volet latéral Outlook",
    "cardIntro": "Déployez le complément une fois via Microsoft 365 Centralized Deployment, puis activez-le par boîte dans l’onglet Utilisateurs. Les défauts ci-dessous s’appliquent uniquement aux boîtes nouvellement synchronisées.",
    "setupWizard": "Assistant de configuration",
    "sidebarDefault": "Activer le volet latéral pour les nouvelles boîtes",
    "allowDefault": "Autoriser les modifications en libre-service pour les nouvelles boîtes",
    "editableFields": "Champs que les utilisateurs finaux peuvent modifier",
    "editableFieldsDesc": "p. ex. mobile, titre. Les champs d’identité ne sont jamais modifiables.",
    "fieldPlaceholder": "Ajouter une clé de champ de fusion",
    "manifestUrl": "URL du manifeste",
    "manifestCopied": "URL du manifeste copiée.",
    "save": "Enregistrer les paramètres Outlook",
    "saved": "Paramètres du volet latéral Outlook enregistrés.",
    "saveFailed": "Impossible d’enregistrer.",
    "gateNote": "Les interrupteurs Volet latéral / Autoriser les modifications par boîte dans l’onglet Utilisateurs contrôlent l’accès après le déploiement.",
    "wizardTitle": "Déployer le complément de signature Outlook",
    "wizardIntro": "Centralized Deployment installe le complément pour les utilisateurs Microsoft 365 assignés. Ensuite, activez Volet latéral (et éventuellement Autoriser les modifications) par boîte dans l’onglet Utilisateurs — le déploiement seul n’ouvre pas les paramètres pour tout le monde.",
    "stepPrereq": "Prérequis",
    "stepManifest": "URL du manifeste",
    "stepUpload": "Téléverser dans le centre d’administration",
    "stepAssign": "Assigner les utilisateurs",
    "stepEnable": "Activer les boîtes",
    "stepVerify": "Vérifier dans Outlook",
    "completeTitle": "Liste de contrôle de déploiement terminée",
    "completeBody": "Les utilisateurs devront peut-être redémarrer Outlook. Le bouton du ruban peut mettre jusqu’à quelques heures à apparaître pour tout le monde. Si le volet indique que l’organisation n’a pas activé les paramètres de signature, activez Volet latéral pour cette boîte dans Utilisateurs.",
    "finish": "Terminer",
    "beforeStart": "Avant de commencer",
    "prereqAdmin": "Connectez-vous au centre d’administration Microsoft 365 en tant qu’administrateur général ou administrateur des applications Office.",
    "prereqOutlook": "Les utilisateurs ont besoin d’Exchange Online / Microsoft 365 Outlook (Outlook classique perpétuel n’est pas pris en charge pour ce complément).",
    "prereqHttps": "Le manifeste XML seul du complément est hébergé en HTTPS par OnBrandMail — collez l’URL ; vous ne téléversez pas de fichier depuis le disque.",
    "copyManifestTitle": "Copier l’URL du manifeste",
    "copyManifestBody": "Microsoft valide ce lien XML lors du déploiement. Conservez-le en HTTPS et ne réécrivez pas le chemin (il doit se terminer par manifest.xml).",
    "uploadTitle": "Téléverser dans le centre d’administration Microsoft 365",
    "uploadStep1": "Ouvrez Paramètres → Applications intégrées dans le centre d’administration.",
    "uploadStep2": "Choisissez Téléverser des applications personnalisées (ou Déployer le complément si vous êtes sur la page des compléments).",
    "uploadStep3": "Définissez le type d’application sur Complément Office (pas une application Teams).",
    "uploadStep4": "Sélectionnez Fournir un lien vers le fichier manifeste, collez l’URL XML de l’étape précédente, puis Valider / Téléverser.",
    "uploadStep5": "Acceptez les demandes d’autorisation lorsqu’elles s’affichent afin qu’Outlook puisse ouvrir le volet de signature.",
    "openIntegratedApps": "Ouvrir Applications intégrées",
    "pilotHint": "Préférez d’abord un groupe de sécurité pilote (les mêmes personnes que pour le pilote de flux de messagerie). Vous pourrez élargir l’assignation plus tard sans retéléverser le manifeste.",
    "assignTitle": "Qui reçoit le complément",
    "assignIntro": "L’assignation ici n’installe que le bouton Outlook. Elle n’accorde pas le libre-service de signature — cela reste dans l’onglet Utilisateurs.",
    "assignSpecific": "Utilisateurs/groupes spécifiques — recommandé. Commencez par votre groupe pilote OnBrandMail.",
    "assignEveryone": "Tout le monde — adapté une fois prêt ; le volet affiche encore un état vide jusqu’à ce que Volet latéral soit activé pour cette boîte.",
    "assignJustMe": "Moi seulement — utile pour valider le ruban avant d’élargir le déploiement.",
    "assignDeploy": "Sélectionnez Déployer / Terminer le déploiement lorsque l’assistant le demande. Microsoft peut prendre de quelques minutes à plusieurs heures avant que le bouton n’apparaisse pour chaque assigné.",
    "enableTitle": "Activer les boîtes dans OnBrandMail",
    "enableIntro": "Centralized Deployment est à l’échelle de l’organisation ; OnBrandMail contrôle l’expérience par personne.",
    "enableStep1": "Ouvrez l’onglet Utilisateurs pour ce locataire.",
    "enableStep2": "Activez Volet latéral pour chaque boîte pilote (ou utilisez Mise à jour massive → Volet latéral Outlook : activer).",
    "enableStep3": "Activez éventuellement Autoriser les modifications pour que ces personnes puissent choisir un modèle et modifier des champs gouvernés. Laissez-le désactivé pour un aperçu uniquement.",
    "enableStep4": "Les administrateurs du locataire obtiennent toujours le volet élevé pour leur propre boîte, même si Volet latéral est désactivé.",
    "enableDefaultsNote": "Les défauts de cette carte Paramètres s’appliquent uniquement aux boîtes nouvellement synchronisées. Les personnes existantes ont besoin des interrupteurs Utilisateurs (ou de la mise à jour massive).",
    "verifyTitle": "Vérifier dans Outlook",
    "verifyStep1": "Redémarrez le nouvel Outlook / Outlook sur le web pour un utilisateur pilote.",
    "verifyStep2": "Ouvrez un message ou une fenêtre de rédaction et cherchez le bouton Signature sur le ruban.",
    "verifyStep3": "Le volet doit afficher leur aperçu et « pourquoi cette signature ». Si les paramètres sont verrouillés, c’est attendu lorsque Autoriser les modifications est désactivé.",
    "verifyStep4": "En tant qu’administrateur du locataire, confirmez que la bandeau admin et la recherche de boîte apparaissent lorsque vous ouvrez le volet vous-même.",
    "verifyManifestHint": "Si la validation de l’URL du manifeste échoue dans le centre d’administration, confirmez que l’URL renvoie du XML (OfficeApp) en HTTPS depuis un navigateur hors de votre réseau.",
    "theUrl": "l’URL"
  }
}
